import {ObjectLink} from '../../../object-detail/object-title/object-link.model';

export class ObjectDetailTitle{

  authors: ObjectLink[] = [];

  title: ObjectLink;

  extras: string[] = [];

  constructor(attr:{authors: ObjectLink[], title: ObjectLink, extras: string[]}) {
    this.authors = attr.authors;
    this.title = attr.title;
    this.extras = attr.extras;
  }
}
